import {
  WSElement,
  WSElementProps,
  WSPill
} from "@wingspanhq/fe-component-library";

import React from "react";

/**
 * Typed on the one field it reads rather than on a model, so the v3
 * `SyncActivity` (QBO history panels) and the v1 activity the not-yet-migrated
 * Settings sync-details screen still holds both satisfy it without this
 * component importing either.
 */
type Props = {
  latestActivity: { isError?: boolean };
} & WSElementProps;

export const QuickbooksSyncBadge: React.FC<Props> = ({
  latestActivity,
  ...elementProps
}) => (
  <WSElement {...elementProps}>
    {latestActivity.isError ? (
      <WSPill theme="error" icon text="Error" />
    ) : (
      <WSPill theme="success" icon text="Synced" />
    )}
  </WSElement>
);
